import { render, staticRenderFns } from "./CreateBanner.vue?vue&type=template&id=98fdced6&scoped=true&lang=pug&"
import script from "./CreateBanner.vue?vue&type=script&lang=js&"
export * from "./CreateBanner.vue?vue&type=script&lang=js&"
import style0 from "./CreateBanner.vue?vue&type=style&index=0&id=98fdced6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fdced6",
  null
  
)

export default component.exports